import { StoreMainBanner } from '@/model';
import {
  GetStoreMainBannerByIdResponse,
  GetStoreMainBannerItemResponse,
  GetStoreMainBannerResponse,
  PostStoreMainBannerByIdResponse,
  PutStoreMainBannerByIdResponse,
} from '@/services/response/store-main-banner';

export class StoreMainBannerConverter {
  static toDomainFromGetItemResponse(response: GetStoreMainBannerItemResponse): StoreMainBanner {
    return {
      uuid: response.uuid,
      title: response.title,
      image_url: response.image_url,
      source_url: response.source_url,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetStoreMainBannerResponse): StoreMainBanner[] {
    return response.data.map(StoreMainBannerConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromByIdResponse(response: GetStoreMainBannerByIdResponse): StoreMainBanner {
    return {
      uuid: response.uuid,
      title: response.title,
      image_url: response.image_url,
      source_url: response.source_url,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutStoreMainBannerByIdResponse): StoreMainBanner {
    return {
      uuid: response.uuid,
      title: response.title,
      image_url: response.image_url,
      source_url: response.source_url,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPostResponse(response: PostStoreMainBannerByIdResponse): StoreMainBanner {
    return {
      uuid: response.uuid,
      title: response.title,
      image_url: response.image_url,
      source_url: response.source_url,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
